import CheckRounded from '@mui/icons-material/CheckRounded';
import StyledChip from './styles';

interface CommandChipProps {
  command: string;
  isForbidden?: boolean;
  isDetected?: boolean;
}

// A detected required command is filled and checked; a detected forbidden
// command is filled but not checked (it happened, but that's not a pass) --
// everything not yet detected stays outlined, matching the mockup's "puce
// détectée est pleine et cochée, une puce non détectée reste en contour".
export default function CommandChip(props: CommandChipProps) {
  const { command, isForbidden, isDetected } = props;
  return (
    <StyledChip isForbidden={isForbidden} isDetected={isDetected}>
      {isDetected && !isForbidden && <CheckRounded />}
      {command}
    </StyledChip>
  );
}
